
export interface SubmissionRequestModel {
	readonly listAlias?: string;
	readonly pageNumber?: number;
	readonly itemsPerPage?: number;
	readonly query?:any;
	readonly stringParams?:any
	readonly remoteDataUrl?:string;
}

export interface GetColumnConfigPayload {
	listAlias: string;
	type?: string;
}

export enum FormActionType {
	UPDATE = 'UPDATE',
	CREATE = 'CREATE'
}

export interface LoadFormPayload{
	formAlias:string,
	version?:number
}

export interface SubmissionRequestPayload{
	formAlias: string,
	formData: any,
	submissionUrl?: string
}

export interface  GridActions {
	icon: any,
	tooltip: string,
	onClick: (_event: any, rowData: any) => void
}